'use strict';

var PooledSeasonalityInputDataSaveExclusionsModalController = function PooledSeasonalityInputDataSaveExclusionsModalController($scope, reviewConstants) {
  $scope.exclusionMenuOptions = reviewConstants.OUTLIER_MENU;
  $scope.saveExclusionOption = reviewConstants.OUTLIER_SAVE_OPTIONS.SELECTED;
  $scope.closeModal = function () {
    $scope.$emit('pooled-seasonality:exclusions-toggle');
  };
  $scope.saveExclusions = function () {
    $scope.$emit('pooled-seasonality:save-exclusions', $scope.saveExclusionOption);
    $scope.saveExclusionOption = reviewConstants.OUTLIER_SAVE_OPTIONS.SELECTED;
  };
};
PooledSeasonalityInputDataSaveExclusionsModalController.$inject = ['$scope', 'PooledSeasonalityReviewConstants'];
module.exports = PooledSeasonalityInputDataSaveExclusionsModalController;